"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import SourceCard from "@/app/(components)/generics/cards/SourceCard/SourceCard";
import IconSparkles from "@/app/(components)/generics/Icons/IconSparkles";
import OrSeparator from "@/app/(components)/generics/OrSeparator/OrSeparator";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { URLs } from "@/app/utils/URLs";
import { Routes } from "@/app/vars/Routes";
import styles from "./OffersEmpty.module.css";

type Props = DefaultProps & {
  canManage: boolean;
  onExtract?: () => void;
};

export default function OffersEmpty(props: Props) {
  const { canManage, onExtract } = props;

  const T = useT();

  if (!canManage) {
    return <p className={styles.reader}>{T(TKey.PROJECT_OFFERS_EMPTY)}</p>;
  }

  return (
    <div className={styles.cards}>
      {onExtract && (
        <SourceCard
          title={T(TKey.OFFERS_EXTRACT_TITLE) as string}
          badge={T(TKey.OFFERS_EXTRACT_BADGE) as string}
          description={T(TKey.OFFERS_EXTRACT_DESCRIPTION) as string}
          benefits={[
            T(TKey.OFFERS_EXTRACT_BENEFIT_1) as string,
            T(TKey.OFFERS_EXTRACT_BENEFIT_2) as string,
            T(TKey.OFFERS_EXTRACT_BENEFIT_3) as string,
          ]}
          actions={
            <Button
              min={true}
              isLink={false}
              type={ButtonType.PRIMARY}
              text={T(TKey.OFFERS_EXTRACT_CTA) as string}
              onClick={onExtract}
            />
          }
        />
      )}

      {onExtract && <OrSeparator />}

      <SourceCard
        icon={<IconSparkles size={26} />}
        title={T(TKey.OFFERS_GENERATE_TITLE) as string}
        badge={T(TKey.OFFERS_GENERATE_BADGE) as string}
        description={T(TKey.OFFERS_GENERATE_DESCRIPTION) as string}
        benefits={[
          T(TKey.OFFERS_GENERATE_BENEFIT_1) as string,
          T(TKey.OFFERS_GENERATE_BENEFIT_2) as string,
          T(TKey.OFFERS_GENERATE_BENEFIT_3) as string,
        ]}
        actions={
          <Button
            min={true}
            isLink={true}
            href={URLs.pathOf(Routes.MCP_GUIDE)}
            type={ButtonType.PRIMARY}
            text={T(TKey.OFFERS_GENERATE_CTA) as string}
          />
        }
      />
    </div>
  );
}
